function LoadingScreen(): JSX.Element {
  return (
    <div className="ring">Loading
      <span></span>
    </div>
  );
}

export default LoadingScreen;
